<template>
  <div class="table-box setTable">
    <loading :isShow="listLoading" />
    <Table :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.policyStatus == '1'">已承保</span>
        <span v-if="row.policyStatus == '-1'">已退保</span>
        <span v-if="row.policyStatus == '0'">已终止</span>
        <div v-if="row.type == '3'">
          <span v-if="row.endorsementVo.status == '50'">已完成</span>
          <span v-if="row.endorsementVo.status == '-99'">保全撤销</span>
          <span v-if="row.endorsementVo.status == '-20'">批改失败</span>
          <span v-if="row.endorsementVo.status == '-15'">核保失效</span>
          <span v-if="row.endorsementVo.status == '0'">待提交</span>
          <span v-if="row.endorsementVo.status == '20'">待支付/确认</span>
          <span v-if="row.endorsementVo.status == '30'">待实收</span>
          <span v-if="row.endorsementVo.status == '40'">待承保</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="fee">
        <span>{{ getfee(row) }}</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <div v-if="row.type == '1'">
          <div class="table-btn" v-if="row.policy.entrance == 2 || row.policy.entrance == 3">
            <div class="action">
              <a class="actionStyle" @click="handlerPolicyDetail(row.policy)">详情</a>
              <a class="actionStyle" v-if="$units.pointAction('order_30_2') && row.policy.entrance == 2"
                @click="modifyPolicy('edit', row.policy)">编辑</a>
              <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row.policy)"
                v-if="row.policy.entrance == 2">
                <div class="more-btn">
                  更多
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="delete"
                    v-if="$units.pointAction('order_30_6') && row.policy.entrance == 2 && row.policy.sourceType == 2">删除
                  </DropdownItem>
                  <DropdownItem name="change" v-if="$units.superviseShowVal()">变更记录</DropdownItem>
                  <DropdownItem name="underlinePolicy"
                    v-if="$units.pointAction('order_30_7') &&
                      ((row.insuranceContract && row.policy.insuranceContract.length != 0) || row.dockChannel == 3)">电子保单</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div class="table-btn" v-else>
            <div class="action">
              <a class="actionStyle" @click="$refs.detailModal.open(row.policy)">详情</a>
              <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row.policy)"
                v-show="$units.pointAction('order_30_7') && row.policy.displayElectronicPolicy == 1">
                <div class="more-btn">
                  更多
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="policy">电子保单</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div class="table-btn" v-if="row.type == '2'">
          <div class="action">
            <span class="actionStyle" @click="groupDetail(row.groupPolicy)">详情</span>
            <span class="actionStyle" @click="editGroupList(row.groupPolicy)" v-if="!(row.groupPolicy.type == 1 || row.groupPolicy.dockChannel == 3) && $units.pointAction('order_50_11')">编辑</span>
            <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick1($event, row.groupPolicy)">
              <div class="more-btn">
                更多
                <Icon type="ios-arrow-down"></Icon>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem name="delete" v-if="!(row.type == 1 || row.dockChannel == 3) && $units.pointAction('order_50_12')">删除</DropdownItem>
                <DropdownItem name="change" v-if="$units.pointAction('order_50_15')">变更归属</DropdownItem>
                <DropdownItem name="policy" v-if="$units.pointAction('order_50_2') && row.groupPolicy.policyUrl && (row.groupPolicy.type == 1 || row.groupPolicy.dockChannel == 3)">
                  下载保单
                </DropdownItem>
                <DropdownItem name="underlinePolicy" v-if="$units.pointAction('order_50_2') && row.groupPolicy.contract && row.groupPolicy.contract.length > 0 && row.groupPolicy.type == 2">
                  电子保单</DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div v-if="row.type == '3'">
          <span class="table-btn" v-if="row.endorsementVo.status != '-99'" @click="detail(row.endorsementVo)">详情</span>
          <span v-else>-</span>
          <span v-if="$units.pointAction('order_40_2_2')&&row.endorsementVo.billFiles && row.endorsementVo.status == '50'" class="table-btn" @click="exportBillFiles(row.endorsementVo)">下载批单</span>
          <span v-if="$units.pointAction('order_40_2_3')&&(row.endorsementVo.status == '-15' || row.endorsementVo.status == '0' || row.endorsementVo.status == '20')" class="table-btn" @click="reset(row.endorsementVo)">撤销</span>
        </div>

        <div v-if="row.type == '4'">
          <div class="table-btn" v-if="row.policyAdditional.entrance == 2 || row.policyAdditional.entrance == 3">
            <div class="action">
              <a class="actionStyle" @click="handlerPolicyDetail(row.policyAdditional)">详情</a>
              <a class="actionStyle" v-if="$units.pointAction('order_30_2') && row.policyAdditional.entrance == 2"
                @click="modifyPolicy('edit', row.policyAdditional)">编辑</a>
              <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row.policyAdditional)"
                v-if="row.policyAdditional.entrance == 2">
                <div class="more-btn">
                  更多
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="change" v-if="$units.superviseShowVal()">变更记录</DropdownItem>
                  <DropdownItem name="underlinePolicy"
                    v-if="$units.pointAction('order_30_7') &&
                      ((row.insuranceContract && row.policyAdditional.insuranceContract.length != 0) || row.dockChannel == 3)">电子保单</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div class="table-btn" v-else>
            <div class="action">
              <a class="actionStyle" @click="$refs.detailModal.open(row.policyAdditional)">详情</a>
              <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row.policyAdditional)"
                v-show="$units.pointAction('order_30_7') && row.policyAdditional.displayElectronicPolicy == 1">
                <div class="more-btn">
                  更多
                  <Icon type="ios-arrow-down"></Icon>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem name="policy">电子保单</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </template>
    </Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
      style="text-align: center" v-if="tableData.length" />
    <!-- 线下保单详情 -->
    <policyDetail ref="policyDetailRef"></policyDetail>
    <!-- 线上保单详情  -->
    <detailModal ref="detailModal"></detailModal>
    <!-- 变更记录 -->
    <change-record ref="changeRecord"></change-record>
    <!-- 划单 -->
    <order-transfer ref="orderTransfer" @success="searchAjax"></order-transfer>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filters from "@/api/filter";
import changeRecord from '@/pages/orderManage/insuredOrder/components/changeRecord';
import policyDetail from '@/pages/orderManage/insuredOrder/components/policyDetail';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';
import orderTransfer from '@/pages/orderManage/group/policy/components/orderTransfer';
export default {
  mixins: [pageTool, common],
  components: {
    changeRecord,
    policyDetail,
    orderTransfer,
    detailModal
  },
  data() {
    return {
      pageSize: 5,
      columns: [
        {
          title: "保单号/批单号",
          align: "left",
          fixed: 'left',
          width: 180,
          render(h, params) {
            if(params.row.billNo){
              return <span>{params.row.policyNo}/{params.row.billNo}</span>;
            }else{
              return <span>{params.row.policyNo}</span>;
            }
            
          },
        },
        {
          title: '产品名称（产品编码）',
          key: 'productName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            if(params.row.productName){
              if(params.row.grade){
                return <span>{params.row.productName}({params.row.productCode})-{params.row.grade}</span>;
              }else{
                return <span>{params.row.productName}({params.row.productCode})</span>;
              }
              
            }else{
              return <span></span>
            }
            
          },
        },
        {
          title: '险种名称',
          key: 'name',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            if(params.row.policyAdditional){
                return <span>{params.row.policyAdditional.name}</span>;
            }else{
              return <span></span>
            }
            
          },
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.insureTime, "YYYY-MM-DD")
            return (
              <span>{res}</span>
            );
          },
        },
        {
          title: '险种分类',
          key: 'themeName',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '保费（元）',
          slot: 'fee',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '保单状态',
          slot: 'status',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '无佣金的原因',
          key: 'reason',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return (
              <span style="color:red">{params.row.reason}</span>
            );
          },
        },
        {
          title: '投/被保险人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const res = params.row.insuranceName
              ? params.row.holderName + "/" + params.row.insuranceName
              : params.row.holderName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 150
        }
      ],
    }
  },
  methods: {
    getfee(row){
      if(row.fee){
         if(row.type == '3'){
          if(row.endorsementVo.type == '1'){
            return row.fee+'(增保)'
          }else if(row.endorsementVo.type == '3'){
            return row.fee+'(减保)'
          }
        }else{
          return row.fee
        }
      }else{
        return ''
      }
      
    },
    reset(row) {
      this.$notice.inquiry('请确认是否要撤销？').then(async () => {
        this.$http({
          url: `/buz/endorsement/cancel`,
          type: "GET",
          data: {
            businessNo: row.businessNo
          },
          apiPermissionCode:'order_40_2_3'
        }).then((res) => {
          this.$Message.success("操作成功");
          this.initListAjax('/buz/endorsement/read/list');
        })
      })
    },
    // 详情
    detail(row) {
      // 桐心企业保
      if(row.policyType == 1 || row.dockChannel == 3){
        this.$http({
          url: `/buz/endorsement/detail?id=${row.id}`,
          type: "GET",
        }).then((res) => {
          window.open(res.data, "_blank");
          
        })
      }else{
        this.openPageTabTags('/orderManage/group/peservation/detail', { id: row.id, policyNo: row.policyNo,workName:'workName' });
      }      
    },
    exportBillFiles(row) {
      window.open(row.billFiles);
    },
    dropdownClick1(e, item) {
      if (e == 'delete') {
        this.delGroupList(item);
      } else if (e == 'change') {
        this.$refs.orderTransfer.open(item, '变更归属');
      } else if (e == 'policy') {
        window.open(item.policyUrl, '_blank');
      } else if (e == 'underlinePolicy') {
        this.goGUnderlinePolicy(item);
      } else if (e == 'copy') {
        this.editGroupList(item, 'copy');
      }
    },
    goGUnderlinePolicy(item) {
      if (item.contract.length > 1) {
        this.urlList = item.contract.map(i => {
          return { path: i.url, fileName: i.url.split('/')[i.url.split('/').length - 1] };
        });
        this.showPolicy = true;
      } else {
        let path = item.contract[0].url;
        if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
          this.urlList = item.contract.map(i => {
            return { path: i.url, fileName: i.url.split('/')[i.url.split('/').length - 1] };
          });
          this.showPolicy = true;
        } else if (this.checkType(path) == 'pdf') {
          window.open(path, '_blank');
        } else {
          location.href = path;
        }
      }
    },
    // 删除
    delGroupList(row) {
      this.$Modal.confirm({
        title: '确定删除吗？',
        onOk: () => {
          this.$http({
            url: `/buz/grouppolicy/enter/delete`,
            type: 'GET',
            data: {
              policyNo: row.policyNo
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.searchAjax();
            this.$emit('getTab')
          });
        },
        onCancel: () => {}
      });
    },
    groupDetail(row = {}) {
      this.$router.push({
        path: '/orderManage/group/policyDetail',
        query: {
          id: row.id || '',
          policyNo: row.policyNo,
          orderNo: row.orderNo,
          dockChannel: row.dockChannel,
          payType: row.payType,
          productCategory: row.productCategory, //1-团险 2-财产险 3、个险
          status: row.status, //保单状态 1-保障中 -1-退保 0-终止
          type: row.type,
          workName:'workName'
        }
      });
    },
    // 编辑
    editGroupList(row, flag='edit') {
      this.openPageTabTags('/orderManage/group/editGroupPolicy', {
        id: row.id,
        policyNo: row.policyNo,
        editFlag: flag,
        workName:'workName'
      });
    },
    // 新增，编辑
    modifyPolicy(flag, row) {
      if (flag == 'add') {
        sessionStorage.reloadPolicyData = '1';
        this.$router.push({
          path: '/orderManage/insuredOrder/addPolicy',
          query: { pageFlag: flag,
        workName:'workName' }
        });
      } else if (flag == 'edit') {
        this.openPageTabTags('/orderManage/insuredOrder/editPolicy/' + row.policyNo, {
          pageFlag: 'edit',
          pageName: 'policyManage',
          id: row.id,
          policyNo: row.policyNo,
          workName:'workName'
        });
      } else if (flag == 'delete') {
        this.$Modal.confirm({
          title: '删除',
          content: '<p>确认删除操作?</p>',
          loading: true,
          onOk: () => {
            this.$http({
              url: '/buz/offlinePolicy/delEnterPolicy',
              type: 'GET',
              data: { policyNo: row.policyNo },
              apiPermissionCode: 'order_30_6'
            })
              .then(res => {
                this.searchParams.pageNo = 1;
                this.getList();
                this.$Modal.remove();
                this.$Message.success('删除成功');
                this.$emit('getTab')
              })
              .catch(err => {
                this.$Modal.remove();
              });
          }
        });
      }
    },
    //获取电子保单
    async getPro(item) {
      const res = await this.$http({
        url: '/buz/policy/getDownloadUrl',
        type: 'GET',
        data: {
          policyNo: item.policyNo
        },
        apiPermissionCode: 'order_30_7'
      });
      if (res.data) {
        this.policyNo = res.data;
        const target = this.$refs.policyNoBox;
        this.$nextTick(() => {
          target.click();
        });
      }
    },
    // 线下单子保单
    goUnderlinePolicy(item) {
      if (item.dockChannel == 3) {
        // 凤栖的单
        this.$units.downloadFile('/buz/policy/downloadFqyfPolicy', { policyNo: item.policyNo }, 'GET');
        return;
      }
      if (item.insuranceContract.length > 1) {
        this.urlList = item.insuranceContract.map(i => {
          return { path: i, fileName: i.split('/')[i.split('/').length - 1] };
        });
        this.showPolicy = true;
      } else {
        let path = item.insuranceContract[0];
        if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
          this.urlList = item.insuranceContract.map(i => {
            return { path: i, fileName: i.split('/')[i.split('/').length - 1] };
          });
          this.showPolicy = true;
        } else {
          window.open(path, '_blank');
        }
      }
    },
    dropdownClick(e, item) {
      if (e == 'delete') {
        this.modifyPolicy('delete', item);
      } else if (e == 'change') {
        this.$refs.changeRecord.open(item);
      } else if (e == 'policy') {
        this.getPro(item);
      } else if (e == 'underlinePolicy') {
        this.goUnderlinePolicy(item);
      }
    },
    handlerPolicyDetail(row) {
      this.$refs['policyDetailRef'].open(row);
    },
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/workBenches/noComPolicy',
        type: 'post',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
  },
  mounted() {
    this.getList()
  }

}
</script>

<style lang="scss" scoped>
.actionStyle {
  color: #236dff;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  margin-right: 5px;
}
.table-box{
  padding-bottom: 10px;
}
</style>